import { Module } from '@nestjs/common';
import { TypeOrmModule } from '@nestjs/typeorm';
import { ApplicationExceptionHandler } from '@project-management-system/backend-utils';
import { FabricRequestCodeEntity } from './entities/fabric-request-code-entity';
import { TrimRequestCodeEntity } from './entities/trim-request-code.entity';
import { ItemReqCodeController } from './item-req-code.controller';
import { FabricReqCodeService } from './fabric-request-code.service';
import { TrimReqCodeService } from './trim-req-code.service';
import { M3FabricContentRequestEntity } from './entities/m3-fabric-content-request-entity';
import {FabricRequestCodeRepository} from './fabric-request-code-repository'
import { M3FabricYarnRequestEntity } from './entities/m3-fabric-yarn-request-entity';
import { EmployeeDetailsRepo } from '../employee-details/dto/employee-detail-repository';
import { EmplyeeDetails } from '../employee-details/dto/employee-details-entity';
import { EmployeeBuyerMappingService } from '../employee-buyer-mapping/employee-buyer-mapping.service';
import { EmployeeBuyerMappingRepository } from '../employee-buyer-mapping/employee-buyer-mapping.repo';
import { EmployeeBuyerMapping } from '../employee-buyer-mapping/employee-buyer-mapping.entity';
import { BuyersService } from '../buyers/buyers.service';
import { BuyersAdapter } from '../buyers/dto/buyers.adapter';
import { Buyers } from '../buyers/buyers.entity';
import { Address } from '../vendors/address.entity';
import { BuyerRepository } from '../buyers/buyers.repository';
import { FabricRequestCodeFiles } from './entities/m3_fabric_request_code_files';


@Module({
  imports: [
    TypeOrmModule.forFeature([FabricRequestCodeEntity,TrimRequestCodeEntity,M3FabricContentRequestEntity,M3FabricYarnRequestEntity,EmplyeeDetails,EmployeeBuyerMapping,Buyers,Address,FabricRequestCodeFiles]),
  ],
  controllers: [ItemReqCodeController],
  providers: [FabricReqCodeService,ApplicationExceptionHandler,TrimReqCodeService,FabricRequestCodeRepository,EmployeeDetailsRepo,EmployeeBuyerMappingService,EmployeeBuyerMappingRepository,BuyersService,BuyersAdapter,BuyerRepository],
  exports: [FabricReqCodeService,TrimReqCodeService,BuyersService]
})
export class RequestCodeModule {}
